export const MuiTab = {
    styleOverrides: {
        root: {
            textTransform: 'none',
            minWidth: 120,
            whiteSpace: 'nowrap'
        }
    }
}
